var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._b({on:{"click":_vm.openFreshWidget}},'q-btn',_vm.getProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }